import { useQuery } from "@tanstack/react-query";
import type { CommissionSummary } from "@shared/utils/commissionSummary";

/**
 * DEV-328: server-computed commission summary shared by Agency > Commissions
 * ("agency") and /my-commissions ("me"). Keyed under "/api/commissions" so the
 * existing commission-mutation invalidations refresh it too.
 */
export function useCommissionSummary(scope: "agency" | "me", month: string, asOf: string) {
  return useQuery<CommissionSummary>({
    queryKey: ["/api/commissions", "summary", scope, month, asOf],
    queryFn: async () => {
      const params = new URLSearchParams({ scope, month, asOf });
      const res = await fetch(`/api/commissions/summary?${params}`, { credentials: "include" });
      if (!res.ok) throw new Error(`Failed to load commission summary (${res.status})`);
      return res.json();
    },
    enabled: !!month && !!asOf,
  });
}
